export const verify_otp = "https://api.roamhome.in/api/v2/public/jetson/verify_otp"
export const generate_token = "https://api.roamhome.in/api/v2/public/jetson/generate_token"
export const check_account = "https://api.roamhome.in/api/v2/public/jetson/check_account"
export const fetch_home = "https://api.roamhome.in/api/v2/jetson/fetch/fetch_home"
export const fetch_calendar = "https://api.roamhome.in/api/v2/jetson/fetch/calendar_reservations"
export const fetch_payout = "https://api.roamhome.in/api/v2/jetson/fetch/fetch_payout"
export const block_date = "https://api.roamhome.in/api/v2/jetson/action/create_block"